<template>
  <div>
    <el-form label-position="left" label-width="150px">

      <el-divider content-position="left">申请人信息</el-divider>

      <el-form-item label="申请人" prop="">
        <el-input v-model="user.realName" readonly></el-input>
      </el-form-item>
      <el-form-item label="所属部门" prop="">
        <el-input v-model="user.deptName" readonly></el-input>
      </el-form-item>

      <el-divider content-position="left">项目信息</el-divider>

      <el-form-item label="所属项目" prop="projectName">
        <el-input v-model="detail.projectName" readonly></el-input>
      </el-form-item>

      <el-form-item label="交付类型" prop="deliveryType">
        <el-checkbox-group v-model="deliveryTypeList" style="cursor: not-allowed;pointer-events:none">
          <el-checkbox label="1">系统评估</el-checkbox>
          <el-checkbox label="2">方案评估</el-checkbox>
          <el-checkbox label="3">方案编制</el-checkbox>
          <el-checkbox label="4">密码应用</el-checkbox>
          <el-checkbox label="5">密码整改</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="联系方式" prop="contact">
        <el-input v-model="detail.contact" readonly></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="remarks">
        <el-input type="textarea" rows=5 v-model="detail.remarks" readonly></el-input>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import {requestApplyDetail} from "@/api";
import ProjectDeliveryDetailsDialog from "@/components/item/common/ProjectDeliveryDetailsDialog.vue";
export default {
  name: "ProjectDialog",
  components: {ProjectDeliveryDetailsDialog},
  props: {
     "applyId": "",
     "applyServiceId": "",
     "applyType": "",
     "role": 0
  },
  data() {
    return {
      audits: [],
      auditHistory: [],
      nodes: [],
      detail: {},
      user: {},
      deliveryTypeList: []
    }
  },
  created() {
    this.getObject()
  },
  methods: {
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType,
      }).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.detail = res.object.detail
            this.user = res.object.user
            this.nodes = res.object.nodes
            this.audits = res.object.audits
            this.auditHistory = res.object.auditHistory
            this.deliveryTypeList = this.detail.deliveryType.split(',')
            console.log(this.detail)
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>
